import theme from './theme';
const smallFooter = props => theme(props).smallFooter;
export const smallFooterBgColor = props => smallFooter(props).backgroundColor;
export const smallFooterTextColor = props => smallFooter(props).textColor;
export const smallFooterLinkColor = props => smallFooter(props).linkColor;